import React from 'react'

import { MessageTemplateManagementModal } from 'components/modals/MessageTemplateManagementModal/MessageTemplateManagementModal'
import { Pane } from 'components/shared/Pane/Pane'
import { SearchWidget } from 'components/shared/SearchWidget/SearchWidget'
import { MessagesTable } from './common/MessagesTable/MessagesTable'
import { DepartmentFilter } from 'components/shared/DepartmentFilter/DepartmentFilter'

import { useMessageTemplates } from './hook'

import styles from './Messages.module.scss'

export const Messages = () => {
  const { state, handlers } = useMessageTemplates()

  const {
    search,
    template,
    isMessageTemplateManagementModalOpen,
    departmentValue,
    filter,
  } = state
  const {
    handleMessageTemplateManagementModalClose,
    handleMessageTemplateManagementModalConfirm,
    handleEdit,
    setSearch,
    setDepartment,
  } = handlers

  return (
    <>
      <Pane.Header className={styles.header}>
        <DepartmentFilter
          value={departmentValue}
          onChange={setDepartment}
          className={styles.departmentFilter}
        />
        <SearchWidget query={search} onChange={setSearch} />
      </Pane.Header>
      <MessagesTable onEdit={handleEdit} {...{ filter, search }} />
      <MessageTemplateManagementModal
        onCancel={handleMessageTemplateManagementModalClose}
        onClose={handleMessageTemplateManagementModalClose}
        onConfirm={handleMessageTemplateManagementModalConfirm}
        isOpen={isMessageTemplateManagementModalOpen}
        {...{ template }}
      />
    </>
  )
}
